import React, {Component} from 'react';
import MenuCenter from './MenuCenter';
import MenuRight from '../../Containers/Nav/MenuRight';
import MenuLeft from '../../Containers/Nav/MenuLeft';
import lang from '../Lang/lang.json';

class Menu extends Component {
  constructor(){
    super();
    this.state = {
      menutype: "date"
    }
  }
  componentWillReceiveProps(){
    if (this.props.usr !== undefined) {
      this.setState({menutype: "usr"})
    } else if (this.props.tab !== undefined) {
      this.setState({menutype: "SelectedTab"})
    }
  }
  render(){
    let {date, type, logout} = this.props;
    if (type === "tableros") {
      return(
        <nav>
          <MenuLeft uPer={this.props.uPer} icons="admin" logout={logout}/>
          <MenuCenter 
            menutype="date"
            lang={this.props.lang} 
            locale={this.props.locale} 
            openCalendar={this.props.openCalendar}
            date={date} 
          />
          <MenuRight icons={["addNew"]}/>
        </nav>
      )
    } else if (type === "current") {
      return (
        <nav>
          <MenuLeft uPer={this.props.uPer} icons="admin" funct={this.props.funct}/>
          <MenuCenter 
            menutype="date" 
            lang={this.props.lang} 
            locale={this.props.locale} 
            openCalendar={this.props.openCalendar}
            date={date} 
          />
          <MenuRight icons={["addCard"]} funct={this.props.funct}/>
        </nav>
      )
    } else if (type === "addcard") {
      return (
        <nav>
          <MenuLeft icons="ok" funct={this.props.funct}/>
          <MenuCenter 
            menutype="date"
            lang={this.props.lang} 
            locale={this.props.locale} 
            openCalendar={this.props.openCalendar}
            date={date} 
          />
          <MenuRight icons={["close"]} funct={this.props.funct}/>
        </nav>
      )
    } else if (type === "tablero") {
      return(
        <nav>
          <MenuLeft uPer={this.props.uPer} icons="admin" />
          <MenuCenter 
                menutype="date" 
                lang={this.props.lang} 
                locale={this.props.locale} 
                openCalendar={this.props.openCalendar}
                date={date} 
              />
          <MenuRight icons={["close"]} funct={this.props.funct}/>
        </nav>
      )
    } else if (type === "admin") {
      return(
        <nav>
          <MenuLeft icons="arrowThin"/>
          <MenuCenter 
                menutype="textonly" 
                txt={lang.MenuTxt[this.props.screen][this.props.language]}
              />
          <MenuRight icons={this.props.icons} screen={this.props.screen} openMod={this.props.openMod}/>
        </nav>
      )
    } else if (type === "SelectedUsr") {
      return(
        <nav>
          <MenuLeft icons="arrowThin"/>
          <MenuCenter 
                menutype="usr" 
                usr={this.props.usr !== undefined ? this.props.usr.name : "loading"}
                email={this.props.usr !== undefined ? this.props.usr.email : "loading"}
              />
          <MenuRight icons={["key", "trash"]} openMod={this.props.openMod}/>
        </nav>
      )
    } else if (type === "TabCnf") {
      return(
        <nav>
          <MenuLeft icons="arrowThin"/>
          <MenuCenter 
                menutype="textonly" 
                txt={lang.MenuTxt[this.props.screen][this.props.language]}
              />
          <MenuRight icons={this.props.icons} screen={this.props.screen} openMod={this.props.openMod}/>
        </nav>
      )
    } else if (type === "SelectedTab") {
      return(
        <nav>
          <MenuLeft icons="arrowThin"/>
          <MenuCenter 
                menutype="SelectedTab" 
                tab={this.props.tab !== undefined ? this.props.tab.name : "loading"}
                tabname={this.props.tab !== undefined ? this.props.tab.fullname : "loading"}
              />
          <MenuRight icons={this.props.icons} openMod={this.props.openMod}/>
        </nav>
      )
    } else if (type === "PointCnf") {
      return(
        <nav>
          <MenuLeft icons="arrowThin"/>
          <MenuCenter 
                menutype="textonly" 
                txt={lang.MenuTxt[this.props.screen][this.props.language]}
              />
          <MenuRight icons={this.props.icons} openMod={this.props.openMod}/>
        </nav>
      )
    } else {
      return (
        <div>Choose a correct type</div>
      )
    }
  }
}

export default Menu;


// WEBPACK FOOTER //
// ./src/Components/Menu/Menu.js